import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Text } from '@uhg-abyss/web/ui/Text';
import { isEmpty, isNil } from 'lodash';
import React from 'react';

import { Table } from './components/Table';

/**
 * Widget: CoverageStatus
 *
 * Displays a history of members coverages.
 *
 * @param riskRecord
 * @returns {Element}
 * @constructor
 */
export function CoverageStatus({ riskRecord = {} }) {
  const activeInfo = riskRecord?.activeInfo;
  const sources = riskRecord?.activeInfo?.sources;

  const hasData =
    !isNil(riskRecord) &&
    !isEmpty(riskRecord) &&
    !isNil(activeInfo) &&
    !isEmpty(activeInfo) &&
    !isNil(sources) &&
    !isEmpty(sources);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/CoverageStatus/CoverageStatus.jsx">
      {!hasData ? (
        <Alert title="There is no coverage status data for this risk record." variant="info" />
      ) : (
        <Grid>
          <Grid.Col span={{ xs: '100%' }}>
            <Text css={{ display: 'block', marginBottom: 'var(--abyss-space-sm)' }} size="$sm">
              {`Last Active Date: ${dayjs(activeInfo?.lastActiveIndicatorDate).format('MM/DD/YYYY')}`}
            </Text>
            <Table rows={activeInfo?.sources} />
          </Grid.Col>
        </Grid>
      )}
    </ErrorHandler>
  );
}
